<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="content-wrapper px-5">
    <div class="d-flex mb-3 mt-5">
        <button class="btn btn-info ml-auto btn-size-normal"
                [routerLink]="['./', 'add-roles']">
            <span class="btn-inner--text"
                  i18n>Add Roles</span>
        </button>
    </div>

    <app-data-table-ajax *ngIf="username"
                        [template]="rowTemplate" 
                        #dataTableAjax
                         url="/users/{{username}}/rolescopes"
                         limit="20"
                         [rowHeight]="undefined"
                         [columns]="columns"
                         [extendRow]="true">
        <ng-template #actionTemplate
                     let-row="row">
            <button i18n
                    type="button"
                    class="btn btn-link p-0 m-0 mr-3"
                    (click)="onEditClick(row)">
                <img alt="Manage User Scope"
                     title="Manage User Scope"
                     class="row-icon"
                     src="assets/_ionicons_svg_md-list-box.svg" />
            </button>
            <button i18n
                    type="button"
                    class="btn btn-link p-0 m-0"
                    (click)="onRemoveRow(row)">
                <img alt="Remove From Role"
                     title="Remove From Role"
                     class="row-icon"
                     src="assets/_ionicons_svg_md-trash.svg">
            </button>
        </ng-template>
    </app-data-table-ajax>
</div>

<ng-template #rowTemplate
             let-row="row">
             <app-user-details-row 
                [userName]="{ username: username}"
                [roleRow]="{role:{id:row.role_id}}">
             </app-user-details-row>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-roles-tab/user-details-roles-tab.component.html